import { selectLabelSearchResultsByTerm } from 'selectors/labelings/search'

// used by performance simulator

export const labelSearchResultsByTerm = term => {
  const state = app.store.getState()
  return selectLabelSearchResultsByTerm(state)[term]
}
